import { render, staticRenderFns } from "./OrderPendingPayment-Content.vue?vue&type=template&id=4baa23d7&"
import script from "./OrderPendingPayment-Content.vue?vue&type=script&lang=js&"
export * from "./OrderPendingPayment-Content.vue?vue&type=script&lang=js&"
import style0 from "./OrderPendingPayment-Content.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports